import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import database from './database';
import axios from '../api';

VuexORM.use(VuexORMAxios, { axios, dataKey: 'data' });

export default VuexORM.install(database);
